import React from 'react';
import { motion } from 'framer-motion';
import { Droplets, Shield, Zap } from 'lucide-react';
export function MechanismSection() {
  const phases = [{
    step: '01',
    title: 'CALMA',
    days: 'Días 1–3',
    desc: '“Apaga la cara”. Bajas fricción e irritantes para que tu piel deje de gritar.',
    icon: <Droplets className="w-5 h-5" data-id="element-112" />
  }, {
    step: '02',
    title: 'BARRERA',
    days: 'Días 4–14',
    desc: 'Construyes estabilidad. Rutina mínima, tolerancia, repetición.',
    icon: <Shield className="w-5 h-5" data-id="element-113" />
  }, {
    step: '03',
    title: 'BROTES',
    days: 'Días 15–21',
    desc: 'Controlas brotes sin pagar el precio de volver a irritarte. Con reglas claras.',
    icon: <Zap className="w-5 h-5" data-id="element-114" />
  }];
  return <section className="py-24 px-4 bg-[#2D2A26] text-[#FBF7F4]" data-id="element-115">
      <div className="max-w-5xl mx-auto" data-id="element-116">
        <div className="grid md:grid-cols-2 gap-16 items-center" data-id="element-117">
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8
        }} data-id="element-118">
            <h2 className="text-3xl md:text-4xl font-serif mb-6 text-white" data-id="element-119">
              El Triángulo <br data-id="element-120" />
              <span className="text-[#C4A08A]" data-id="element-121">Calma → Barrera → Brotes</span>
            </h2>
            <p className="text-[#FBF7F4]/80 text-lg mb-8 leading-relaxed" data-id="element-122">
              Es exactamente lo contrario de lo que hace la mayoría: primero
              atacan. Aquí primero estabilizas.
            </p>
            <p className="text-[#FBF7F4]/80 text-lg leading-relaxed" data-id="element-123">
              PIEL EN PERI te guía por 3 fases simples diseñadas para recuperar
              el control sin agresión.
            </p>
          </motion.div>

          <div className="space-y-6" data-id="element-124">
            {phases.map((phase, index) => <motion.div key={index} initial={{
            opacity: 0,
            x: 20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.5,
            delay: index * 0.2
          }} className="flex gap-6 p-6 rounded-lg bg-white/5 border border-white/10 hover:bg-white/10 transition-colors" data-id="element-125">
                <div className="flex-shrink-0" data-id="element-126">
                  <span className="flex items-center justify-center w-10 h-10 rounded-full bg-[#C4A08A] text-[#2D2A26] font-bold font-serif" data-id="element-127">
                    {phase.step}
                  </span>
                </div>
                <div data-id="element-128">
                  <div className="flex items-baseline gap-3 mb-2" data-id="element-129">
                    <h3 className="text-xl font-serif text-white" data-id="element-130">
                      {phase.title}
                    </h3>
                    <span className="text-xs uppercase tracking-wider text-[#C4A08A] border border-[#C4A08A]/30 px-2 py-0.5 rounded-full" data-id="element-131">
                      {phase.days}
                    </span>
                  </div>
                  <p className="text-[#FBF7F4]/70 font-light" data-id="element-132">{phase.desc}</p>
                </div>
              </motion.div>)}
          </div>
        </div>
      </div>
    </section>;
}